export default "__VITE_ASSET__a1VL2ene__"